import { render, staticRenderFns } from "./viewSwitcher.vue?vue&type=template&id=fb710f24&scoped=true"
import script from "./viewSwitcher.vue?vue&type=script&lang=js"
export * from "./viewSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb710f24",
  null
  
)

export default component.exports